import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Card-index-1992f2b707e512df1-1'),
    routerUrl: '/Card',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Card')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Card-index-1992f2b707e512df1-2'),
        routerUrl: '/CardForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./CardForm')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Card-index-1992f2b707e512df1-3'),
        routerUrl: '/CardRefillForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./CardRefillForm')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Card-index-1992f2b707e512df1-4'),
        routerUrl: '/CardRefill',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./CardRefill')),
      },
      //$MORE$
    ],
  },
];
